import SignatureCapture from "./SignatureCapture.vue";

export default SignatureCapture;
export { SignatureCapture };
